import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_sous_titre_1Texte, id_sous_titre_1CouleurTexte, id_sous_titre_1Opacite, id_sous_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_sous_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_sous_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_sous_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_sous_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_sous_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_sous_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div id="id_bloc" className="container-fluid">
                    {/* id_titre_1 */}
                    {id_titre_1Afficher && (
                        <RichText 
                            tagName="h1" 
                            className="id_titre_1 " 
                            value={id_titre_1Texte} 
                            onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                        />
                    )}
                    {/* end-id_titre_1 */}
                    {/* id_sous_titre_1 */}
                    {id_sous_titre_1Afficher && (
                        <RichText 
                            tagName="h2" 
                            className="id_sous_titre_1 " 
                            value={id_sous_titre_1Texte} 
                            onChange={(val) => setAttributes({ id_sous_titre_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_sous_titre_1CouleurTexte, opacity: id_sous_titre_1Opacite }} 
                        />
                    )}
                    {/* end-id_sous_titre_1 */}
                    {/* id_paragraphe_1 */}
                    {id_paragraphe_1Afficher && (
                        <RichText 
                            tagName="p" 
                            className="id_paragraphe_1 " 
                            value={id_paragraphe_1Texte} 
                            onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                        />
                    )}
                    {/* end-id_paragraphe_1 */}
                    {/* id_map_1 */}
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2629.866!2d6.1737156!3d49.1193089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDnCsDA3JzA5LjUiTiA2wrAxMCczMS40IkU!5e0!3m2!1sfr!2sfr!4v1699724400000!5m2!1sfr!2sfr" className="w-100" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="attribut_id_map_1_alt"></iframe>
                    {/* end-id_map_1 */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}